module.exports = __webpack_public_path__ + "img/covid2.8447f793.png";